import React from 'react'
import Connect from '../../components/Connect'
import ServiceAll from './ServiceAll'
import ServiceBanner from './ServiceBanner'
import ServiceNumber from './ServiceNumber'

export default function ServiceListing() {
  const bannerData = {
    image: "/assets/images/servicelist-banner.webp",
    breadcrumb: [
      {
        slug: "/services/",
        name: "Services",
      },
    ]
  }
  return (
    <>
      <ServiceBanner data={bannerData} />
      <ServiceNumber />
      <ServiceAll />
      <Connect />
    </>
  )
}
